import React, { useRef, useEffect } from "react";
import "./PasscodeInput.scss";

const PasscodeInput = ({
  value      = "",
  onChange,
  onComplete,
  invalid    = false,
  disabled   = false,
  masked     = true,
  autoFocus  = false,
  length     = 6,
}) => {
  const inputRefs = useRef([]);

  useEffect(() => {
    if (autoFocus && inputRefs.current[0]) inputRefs.current[0].focus();
  }, [autoFocus]);

  const digits = Array.from({ length }, (unused, index) => value[index] || "");

  const emit = (next) => {
    onChange(next);
    if (next.length === length && onComplete) onComplete(next);
  };

  const focusBox = (index) => {
    const box = inputRefs.current[index];
    // Deferred like the original: typing fast enough to fire two changes in one
    // frame otherwise skips a box.
    if (box) setTimeout(() => box.focus(), 100);
  };

  const handleChange = (index, raw) => {
    const digit = raw.replace(/\D/g, "").slice(-1);
    if (!digit) return;

    const next = digits.slice();
    next[index] = digit;
    const joined = next.join("").slice(0, length);

    emit(joined);
    if (index < length - 1) focusBox(index + 1);
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      event.preventDefault();

      const next = digits.slice();

      if (next[index]) {
        next[index] = "";
        emit(next.join("").replace(/\s/g, ""));
      } else if (index > 0) {
        next[index - 1] = "";
        emit(next.join("").replace(/\s/g, ""));
        focusBox(index - 1);
      }
    } else if (event.key === "ArrowLeft" && index > 0) {
      focusBox(index - 1);
    } else if (event.key === "ArrowRight" && index < length - 1) {
      focusBox(index + 1);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pasted = (event.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, length);
    if (pasted) emit(pasted);
  };

  return (
    <div className={ `wallet-passcode-input ${invalid ? "invalid" : ""}` }>
      { digits.map((digit, index) => (
        <input
          key={ index }
          ref={ (element) => { inputRefs.current[index] = element; } }
          type={ masked ? "password" : "text" }
          inputMode="numeric"
          autoComplete="one-time-code"
          className="passcode-box"
          maxLength={ 1 }
          value={ digit }
          disabled={ disabled }
          onChange={ (e) => handleChange(index, e.target.value) }
          onKeyDown={ (e) => handleKeyDown(index, e) }
          onPaste={ handlePaste }
        />
      )) }
    </div>
  );
};

export default PasscodeInput;
